<template>

    <div class="flex-1  dark:bg-slate-800/75 flex flex-col justify-center items-center bg-gray-200/25 border-l-2 dark:border-l-gray-700 overflow-y-auto"
        v-if="isLoading">
    </div>

    <div ref="messageContent"
        class="flex-1 relative dark:bg-slate-800/75 bg-gray-200/25 border-l-2 dark:border-l-gray-700 overflow-y-auto"
        v-else-if="messages.length">
        <SendFile v-if="fileReply" />
        <template v-else>
            <LoadOldMessage v-if="pagination?.next_page_url" />
            <div class="w-fit right-9 z-30 bottom-20 absolute">
                <div @click="scrollToBottom" ref="scrollBtn"
                    class=" fixed w-fit p-1 rounded-full t bg-teal-900 text-white px-2  ">
                    <i class="las la-arrow-circle-down text-xl"></i>
                </div>
            </div>

            <MessageItem v-for="(message, i) in messages" :message="message" :key="i" />
        </template>

    </div>

</template>
<script>
import { mapFields } from 'vuex-map-fields';
import MessageItem from './MessageItem.vue';
import SendFile from '../widgets/SendFile.vue';
import LoadOldMessage from '../widgets/LoadOldMessage.vue';

export default {
    name: "MessagesMessages",
    components: {
        MessageItem,
        SendFile,
        LoadOldMessage
    },
    computed: {
        ...mapFields("messages/list", {
            isLoading: "isLoading",
            messages: "items",
            isSuccess: "isSuccess",
            messageAlert: "message",
            showMessage: "showMessage",
            pagination: "pagination"
        }),
        ...mapFields("messages/reply", {
            fileReply: "fileReply",
        }),
    }

}
</script>